import colsum from './colsum';
import color from './color';
import colduplicities from './colduplicities';

/**
 * Main class for regitering and execution of functions.
 */
export default class {
    register = new Map();

    constructor(table) {
        this.definitions = table.functions;

        const colsumIns = colsum;
        const colorIns = color;

        this._register('colsum', colsumIns);
        this._register('color', colorIns);
        this._register('colduplicities', colduplicities);
    }

    run(changeAtRow, changeAtCol, data, setValueCallback, setMetadataCallback) {
        this._run(false, changeAtRow, changeAtCol, data, setValueCallback, setMetadataCallback);
    }

    runAll(data, setValueCallback, setMetadataCallback) {
        this._run(true, 0, 0, data, setValueCallback, setMetadataCallback);

    }

    _run(runAll, changeAtRow, changeAtCol, data, setValueCallback, setMetadataCallback) {
        if (!this.definitions) {
            return;
        }

        let applyAtRow;
        let applyAtCol;
        let result;

        for (const def of this.definitions) {
            applyAtRow = def.row;
            applyAtCol = def.col;
            if (runAll || applyAtRow === changeAtRow || applyAtCol === changeAtCol) {
                result = this._executeFunction(data, def);
                if (result.value !== undefined) {
                    setValueCallback(applyAtRow, applyAtCol, result.value);
                }
                const metadata = result.metadata;
                if (metadata !== undefined) {
                    setMetadataCallback(result.metadata);
                }
            }
        }
    }

    _executeFunction(data, def) {
        const func = this._getFunction(def.name);
        if (func == undefined) {
            console.log(`Function '${name}' is not supported!`);
            return undefined;
        }

        return func(data, def.row, def.col, ...def.arguments);
    }

    _register(name, body) {
        this.register.set(name, body);
    }

    _getFunction(name) {
        return this.register.get(name);
    }
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/functions/functionExecutor.js